<div class="banner-highlight">
  <div
    class="bg-container"
    [style.background]="'url(' + imagepathmobile + ')'"
  ></div>

  <video
    [muted]="true"
    autoplay
    playsinline
    loop
  >
    <source src="https://unhide-static-prod.nyc3.cdn.digitaloceanspaces.com/videos/membership/bg-workflow-converted.m4v" type="video/mp4" />
  </video>

  <div class="content">
    <h3>
      {{ membershipPricingMock?.bannerHighlightTranslation[0]?.title }}
    </h3>

    <p>
      {{ membershipPricingMock?.bannerHighlightTranslation[0]?.message }}
    </p>
  </div>
</div>
